export default __webpack_public_path__ + "static/media/building.7f12a806.svg";